import { createContext, useContext } from 'react';
import type { Post } from '../types';

interface PostsContextType {
  posts: Post[];
  queue: Post[];
  createPost: (post: Post) => void;
  deletePost: (postId: string) => void;
  updatePost: (post: Post, scheduledDate?: Date) => void;
  unschedulePost: (postId: string) => void;
  duplicatePost: (post: Post) => void;
  addToQueue: (post: Post, scheduledDate?: Date) => void;
  addToNewsletter: (post: Post) => void;
  /** Recharge la liste des posts depuis l'API (sans skeleton). */
  refreshPosts?: () => Promise<void>;
}

export const PostsContext = createContext<PostsContextType | null>(null);

export function usePostsContext(): PostsContextType {
  const ctx = useContext(PostsContext);
  if (!ctx) throw new Error('usePostsContext must be used within a PostsContext.Provider');
  return ctx;
}
